import MainStore from '@/store/userStore';
import params from '../param';
import BrowserCallNative from './BrowserCallNative.js';
import robotaxi from '../platformUtils/robotaxi';

export default class RobotaxiCallNative extends BrowserCallNative {
  static callNative(name, data) {
    if (!this[name]) {
      return Promise.reject(new Error(`${name}功能在享道App中暂时无法使用`));
    }
    return this[name](data);
  }

  static closeWebView() {
    return robotaxi.closeWebView();
  }

  static getTokenAndKey() {
    const locationHref = window.location.href;
    const {
      hashParams: { token, ticket, userGuid } = {},
    } = params.parseVueRouterLink(locationHref) || {};
    if (token) {
      const userInfo = {
        token,
        ticket: ticket || '',
        userGuid: userGuid || '',
      };
      MainStore.setUserInfo(userInfo);
      return Promise.resolve(userInfo);
    }
    const res = MainStore.getUserStore() || {};
    return Promise.resolve({ ...res });
  }
}
